import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { faTrash, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-Carecteristicas',
    templateUrl: './Carecteristicas.component.html',
    styleUrls: ['./Carecteristicas.component.less'],
    standalone: false
})
export class CarecteristicasComponent implements OnInit, OnChanges {

  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;
  faTrash = faTrash;

  values: string[] = [];

  type: string = "";
  value: string = "";

  @Input() output: string = "";

  @Output() outputChange: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    this.values = [];
    this.output = "";
    if(changes?.output?.currentValue) {
      this.output = changes.output.currentValue;
      if(this.output != null || this.output != undefined){
        this.values = this.output.split(";");
        if(this.values.length != 0)
          this.values = this.values.filter(x => x != '');
      }
    }
  }

  ngOnInit() {
  }

  delete(item) {
    this.values = this.values.filter(x => x != item);
    this.output = "";
    this.values.forEach(el => {
      this.output += el+";";
    });
    this.outputChange.emit(this.output);
  }

  add() {
    if(this.value != "" && this.type != "") {
      this.values.push(this.type+": "+this.value);
      this.output = (this.output == null || this.output == undefined ? "" : this.output + ";")+ this.type+": "+this.value;
      this.outputChange.emit(this.output);
      this.value = "";
      this.type = "";
      this.values = this.values.filter(x => x != '');
    }
  }

  swap(item1: number, item2: number) {
    var temp = this.values[item1];
    this.values[item1] = this.values[item2];
    this.values[item2] = temp;
    this.output="";
    this.values.forEach(el => {
      this.output += el+";";
    });
    this.outputChange.emit(this.output);
  }

}
